import axios from "axios";
import { setupAxiosAuthInterceptor } from "../authentication/axiosAuthInterceptor";

const axiosInstance = axios.create();

const secureAxiosInstance = setupAxiosAuthInterceptor(axiosInstance);

export default secureAxiosInstance;